import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet";

import "./digital.css";
import HeroSection from "./HeroSection";

const BenefitSection = lazy(() => import("./BenefitSection"));
const InnovationSection = lazy(() => import("./InnovationSection"));
const AdvantageSection = lazy(() => import("./AdvantageSection"));

const DigitalTransformation = () => {
  return (
    <main className="bg-white">
      <Helmet>
        <title>
          Digital Transformation Services | Lentera Technologies
        </title>
        <meta
          name="description"
          content="Automate processes, enhance operational efficiency, and reduce errors across industries like manufacturing, healthcare, finance, education, transportation, and retail."
        />
        <meta
          name="keywords"
          content="LENTERA digital innovation, workflow digitization, industry-specific digital transformation, digital tools for business, reduce manual processes, improve business performance, technology-driven growth"
        />
      </Helmet>

      <HeroSection />

      <Suspense
        fallback={
          <div
            role="status"
            aria-live="polite"
            className="h-[400px] flex items-center justify-center"
          >
            Loading...
          </div>
        }
      >
        <BenefitSection />
        <InnovationSection />
        <AdvantageSection />
      </Suspense>
    </main>
  );
};

export default DigitalTransformation;